import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsaDraft } from './jsa-draft.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class JsaDraftService {
  private apiUrl = `${environment.apiConfig.uri}/jsa-draft`;

  constructor(private http: HttpClient) {}

  getDraft(): Observable<{ data: JsaDraft | null }> {
    return this.http.get<{ data: JsaDraft | null }>(this.apiUrl);
  }

  upsertDraft(formData: any): Observable<any> {
    return this.http.put(this.apiUrl, { formData });
  }

  discardDraft(): Observable<any> {
    return this.http.delete(this.apiUrl);
  }
}
